module.exports = __webpack_public_path__ + "img/imageicon.92b2ec7d.svg";